import React from "react";

const LoadingScreen = () => (
  <div className="loading-container">
    <div>Loading...</div>
  </div>
);

export default LoadingScreen;
